module.exports = __webpack_public_path__ + "static/media/radio_corsa.b8ba57e0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/radio_corsa.mp3
// module id = 189
// module chunks = 0